import { forwardRef } from "react";
function SvgRawBoltIcon({ title, titleId, fill = "#545454", ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      <path
        fillRule="evenodd"
        fill={fill}
        strokeWidth={2}
        d="M4 2.75C2.89543 2.75 2 3.64543 2 4.75V14C2 15.1046 2.89543 16 4 16H7.25V18.75V20.885L8.89019 19.5182L13.1121 16H20C21.1046 16 22 15.1046 22 14V4.75C22 3.64543 21.1046 2.75 20 2.75H4ZM4 4.75L20 4.75V14L12.75 14H12.3879L12.1098 14.2318L9.25 16.615V15V14H8.25H4V4.75ZM7.125 10.5C7.74632 10.5 8.25 9.99632 8.25 9.375C8.25 8.75368 7.74632 8.25 7.125 8.25C6.50368 8.25 6 8.75368 6 9.375C6 9.99632 6.50368 10.5 7.125 10.5ZM12.75 9.375C12.75 9.99632 12.2463 10.5 11.625 10.5C11.0037 10.5 10.5 9.99632 10.5 9.375C10.5 8.75368 11.0037 8.25 11.625 8.25C12.2463 8.25 12.75 8.75368 12.75 9.375ZM16.125 10.5C16.7463 10.5 17.25 9.99632 17.25 9.375C17.25 8.75368 16.7463 8.25 16.125 8.25C15.5037 8.25 15 8.75368 15 9.375C15 9.99632 15.5037 10.5 16.125 10.5Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawBoltIcon);
export default ForwardRef;
